<script>
  /* global Global */
  import GamePrepend from './GamePrepend.svelte';
  import GameTeamVisitor from './GameTeamVisitor.svelte';
  import GameTeamHome from './GameTeamHome.svelte';
  import GameAppend from './GameAppend.svelte';
  import GameSmallInfo from './GameSmallInfo.svelte';
  import SeparatorHorizontal from '../SeparatorHorizontal.svelte';
  import GameSmallScore from './GameSmallScore.svelte';

  export let value;
  export let year;
  export let detail = true;
  export let lang = undefined;
  export let user;

  const years = Global.years;
</script>

<a href={detail && ![undefined, null].includes(value.score.visitor) && ![undefined, null].includes(value.score.home) ? `./#/games/${value.number}${year !== years[0] ? `/${year}` : ''}` : undefined}
  class='game' class:game-no-hover={!detail || [undefined, null].includes(value.score.visitor) || [undefined, null].includes(value.score.home)}>

  <div class='game-prepend'>
    <GamePrepend {value} bind:year bind:user/>
  </div>

  <div class='game-teams'>
    <div class='game-teams-team-visitor'>
      <GameTeamVisitor {value} bind:lang/>
    </div>

    <div class='game-teams-team-home'>
      <GameTeamHome {value} bind:lang/>
    </div>
  </div>

  <div class='game-append'>
    <GameAppend {value}/>
  </div>

  {#if value.note[lang]}
    <div class='game-note'>
      *{value.note[lang]}
    </div>
  {/if}
</a>

<a href={![undefined, null].includes(value.score.visitor) && ![undefined, null].includes(value.score.home) ? `./#/games/${value.number}${year !== years[0] ? `/${year}` : ''}` : undefined}
  class='game-small' class:game-small-no-hover={[undefined, null].includes(value.score.visitor) || [undefined, null].includes(value.score.home)}>

  <div class='game-small-info'>
    <GameSmallInfo {value} bind:year bind:user/>
  </div>

  <SeparatorHorizontal/>

  <div class='game-small-teams'>
    <div class='game-small-teams-team-visitor'>
      <GameTeamVisitor {value} bind:lang/>
    </div>

    <div class='game-small-teams-team-home'>
      <GameTeamHome {value} bind:lang/>
    </div>
  </div>

  <div class='game-small-links'>
    <GameSmallScore {value}/>
  </div>

  {#if value.note[lang]}
    <div class='game-small-note'>
      *{value.note[lang]}
    </div>
  {/if}
</a>

<style>
  .game {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 5px;

    padding: 10px 20px;

    border-radius: var(--radius-lg);

    text-decoration: none;

    background: var(--grey-1);
    color: inherit;

    transition: box-shadow 1s ease-in-out;
  }

  .game:not(.game-no-hover):hover {
    box-shadow: 0px 0px 10px 0px var(--grey-4);
  }

  .game-teams {
    display: flex;
    gap: 20px;
  }

  .game-note {
    display: flex;
    align-items: center;

    width: 100%;
    height: 15px;

    font-size: 10px;
    font-weight: 550;
    font-style: italic;
  }

  .game-small {
    display: none;
    flex-direction: column;
    gap: 10px;

    padding: 10px 20px;

    border-radius: var(--radius-lg);

    text-decoration: none;

    background: var(--grey-1);
    color: inherit;

    transition: box-shadow 1s ease-in-out;
  }

  .game-small:not(.game-small-no-hover):hover {
    box-shadow: 0px 0px 10px 0px var(--grey-4);
  }

  .game-small-teams {
    display: flex;
    justify-content: center;
    gap: 20px;
  }

  .game-small-note {
    display: flex;
    align-items: center;

    width: 100%;
    height: 15px;

    font-size: 10px;
    font-weight: 550;
    font-style: italic;
  }

  :global(body.dark) .game {
    background: var(--grey-8);
  }

  :global(body.dark) .game:not(.game-no-hover):hover {
    box-shadow: 0px 0px 10px 0px var(--black);
  }

  :global(body.dark) .game-small {
    background: var(--grey-8);
  }

  :global(body.dark) .game-small:not(.game-small-no-hover):hover {
    box-shadow: 0px 0px 10px 0px var(--black);
  }

  @media only screen and (max-width: 600px) {
    .game {
      display: none;
    }

    .game-small {
      display: flex;
    }
  }
</style>
